import { useQuery } from "@apollo/client/react";
import type { SkynetUserModel } from "../../../models/RolesAndPermissionsModels";
import GET_USER from "../../queries/rolesAndPermissions/getUser";

export const useUser = (id: string, skip = true) => {
  const { data, error, loading, refetch } = useQuery<{
    skynetUser: SkynetUserModel;
  }>(GET_USER, {
    variables: {
      id,
    },
    skip,
  });
  return { skynetUser: data?.skynetUser, error, loading, refetch };
};
